module.exports = __webpack_public_path__ + "img/HU12201923.e5c19a16.svg";